import React, { useState, useEffect } from "react";
import { Icon } from "semantic-ui-react";
import { useIsMounted } from "../../../hooks/useIsMounted";
import { useNotification } from "../../../context/NotificationProvider";

export default function Notification({
  message,
  iconName,
  hex,
  action,
  onClose,
}) {
  const { setNotification } = useNotification();

  const [active, setActive] = useState(false);
  let isMounted = useIsMounted();

  const closeNotification = () => {
    onClose?.();
    setActive(false);

    setTimeout(() => {
      setNotification({ message: null, iconName: null, hex: null });
    }, 300);
  };

  useEffect(() => {
    if (isMounted.current) setActive(true);
    // setTimeout(() => {
    //   if (isMounted.current) setActive(false);
    // }, 7000);

    return () => setActive(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{ "--hex": `${hex}` }}
      className={active ? "uinotification active" : "uinotification"}
    >
      <div className="message">
        <div className="symbol">
          <Icon name={iconName} />
        </div>
        <div className="text">
          <p>{message}</p>
          {action ? (
            <button
              className="default uinotification__action"
              onClick={() => {
                if (action?.action) {
                  action.action();
                  closeNotification();
                }
              }}
            >
              <p>{action?.label}</p>
            </button>
          ) : (
            ""
          )}
        </div>
        <button className="exit default" onClick={() => closeNotification()}>
          <Icon name={"x"} />
        </button>
      </div>
    </div>
  );
}
